import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { kmMessages } from "src/constant/Messages";
import { Skeleton } from "@material-ui/lab";
import { Alert, AlertTitle } from "@material-ui/lab";
import renderHTML from "react-render-html";

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  radiogrp: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

const Form = ({ onSubmit, voting, vote, ...rest }) => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = useState();
  const [memberVoted, setMemberVoted] = useState(false);
  const [alterMemberVoted, setAlterMemberVoted] = useState(false);
  const [currentVoted, setCurrentVoted] = useState(false);

  useEffect(() => {
    if (voting?.selectedVotingOptionId) {
      setCurrentVoted(true);
      setSelectedValue(voting.selectedVotingOptionId.toString());
    }

    if (
      voting?.currentUserVotingRole === "alternate_member" &&
      voting.memberSelectedVotingOptionId
    ) {
      setMemberVoted(true);
      setSelectedValue(voting.memberSelectedVotingOptionId.toString());
    } else if (
      voting?.currentUserVotingRole === "member" &&
      voting.alternateMemberSelectedVotingOptionId
    ) {
      setAlterMemberVoted(true);
      setSelectedValue(voting.alternateMemberSelectedVotingOptionId.toString());
    }

    return () => {};
  }, [voting]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const onSubmitLocal = (event) => {
    event.preventDefault();
    onSubmit(voting.id, parseInt(selectedValue));
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Grid container className={classes.root}>
            <Grid item xs={12}>
              <form onSubmit={onSubmitLocal}>
                {alterMemberVoted ? (
                  <Box pb={2}>
                    <Alert severity="warning" className={classes.kmmessage}>
                      <AlertTitle>
                        <strong>Uwaga! Głos oddany przez Zastępcę</strong>
                      </AlertTitle>
                      <div>
                        {renderHTML(
                          `W dn. <b>${voting.alternateMemberVoteCreatedAt}</b> zagłosował już Zastępca Członka Komitetu, wybierając zaznaczoną poniżej opcję. Zmiana wyboru Zastępcy i użycie przycisku Zapisz spowoduje zmianę głosu. Użycie przycisku Anuluj spowoduje zachowanie głosu Zastępcy.`
                        )}
                      </div>
                    </Alert>
                  </Box>
                ) : (
                  <></>
                )}
                {memberVoted ? (
                  <Box pb={2}>
                    <Alert severity="warning" className={classes.kmmessage}>
                      <AlertTitle>
                        <strong>
                          Uwaga! Głos oddany przez Członka Komitetu
                        </strong>
                      </AlertTitle>
                      <div>
                        {renderHTML(
                          `W dn. <b>${voting.memberVoteCreatedAt}</b> zagłosował już Członek Komitetu, wybierając zaznaczoną poniżej opcję. Zastępca nie ma możliwości zmiany głosu Członka.`
                        )}
                      </div>
                    </Alert>
                  </Box>
                ) : (
                  <></>
                )}
                 {!alterMemberVoted && !memberVoted && currentVoted ? (
                  <Box pb={2}>
                    <Alert severity="warning" className={classes.kmmessage}>
                      <AlertTitle>
                        <strong>Uwaga! Głos oddany</strong>
                      </AlertTitle>
                      <div>
                        {renderHTML(
                          `Już zagłosowałeś dn. <b>${voting.selectedVoteCreatedAt}</b>, wybierając zaznaczoną poniżej opcję. Zmiana wyboru i użycie przycisku Zapisz spowoduje zmianę głosu. Użycie przycisku Anuluj spowoduje zachowanie dotychczasowego głosu.`
                        )}
                      </div>
                    </Alert>
                  </Box>
                ) : (
                  <></>
                )}
                {voting ? (
                  <FormControl
                    component="fieldset"
                    className={classes.formcontrol}
                    onChange={handleChange}
                    disabled={memberVoted}
                  >
                    <FormLabel component="legend">{voting.title}</FormLabel>

                    <RadioGroup
                      aria-label="vote"
                      name="vote"
                      className={classes.radiogrp}
                    >
                      {voting.votingOptions.map((votingOption) => {
                        return (
                          <FormControlLabel
                            checked={
                              selectedValue === votingOption.id.toString()
                            }
                            key={votingOption.id}
                            value={votingOption.id.toString()}
                            control={<Radio color="primary" />}
                            label={votingOption.name}
                          />
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                ) : (
                  <Skeleton />
                )}

                <Box className={classes.paddingtop}>
                  <Button
                    color="primary"
                    className={classes.button}
                    component={RouterLink}
                    to="/glosowania/wtrakcie"
                  >
                    Zamknij
                  </Button>
                  {!memberVoted ? (
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.button}
                      endIcon={<SaveIcon />}
                      type="submit"
                    >
                      Zapisz
                    </Button>
                  ) : (
                    <></>
                  )}
                </Box>
              </form>
            </Grid>
          </Grid>
        </Box>
    </Card>
  );
};

export default Form;
